var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "packaging-search" }, [
    _c(
      "div",
      {
        staticClass: "packaging-search__input-wrapper",
        class: { "is-focused": _vm.isOpen },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchQuery,
              expression: "searchQuery",
            },
          ],
          staticClass: "packaging-search__input",
          class: { "is-focused": _vm.isOpen },
          attrs: { type: "text", placeholder: "Поиск..." },
          domProps: { value: _vm.searchQuery },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.searchQuery = $event.target.value
              },
              _vm.onInput,
            ],
          },
        }),
        _vm._v(" "),
        !_vm.searchQuery
          ? _c("span", { staticClass: "packaging-search__search-icon" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "28",
                    height: "28",
                    viewBox: "0 0 28 28",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M19.748 19.8792L23.8 23.7992M22.4933 13.3459C22.4933 18.3974 18.3982 22.4926 13.3466 22.4926C8.29505 22.4926 4.19995 18.3974 4.19995 13.3459C4.19995 8.29432 8.29505 4.19922 13.3466 4.19922C18.3982 4.19922 22.4933 8.29432 22.4933 13.3459Z",
                      stroke: "#4B4A4A",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                    },
                  }),
                ]
              ),
            ])
          : _c(
              "button",
              {
                staticClass: "packaging-search__clear-button",
                on: { click: _vm.clearSearch },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "28",
                      height: "28",
                      viewBox: "0 0 28 28",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M21 7L7 21M21 21L7 7",
                        stroke: "#4B4A4A",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                      },
                    }),
                  ]
                ),
              ]
            ),
      ]
    ),
    _vm._v(" "),
    _vm.isOpen
      ? _c(
          "ul",
          { staticClass: "packaging-search__dropdown-list" },
          [
            _vm.filteredItems.length > 0
              ? _vm._l(_vm.filteredItems, function (item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "packaging-search__dropdown-item",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "packaging-search__dropdown-link",
                          attrs: { href: item.link },
                        },
                        [
                          item.image
                            ? _c("img", {
                                staticClass: "packaging-search__dropdown-image",
                                attrs: { src: item.image, alt: "" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "packaging-search__dropdown__text" },
                            [_vm._v(_vm._s(item.name))]
                          ),
                        ]
                      ),
                    ]
                  )
                })
              : _c(
                  "li",
                  {
                    staticClass:
                      "packaging-search__no-results packaging-search__dropdown-item",
                  },
                  [_vm._v("\n            Товаров не найдено\n        ")]
                ),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }